import { render, staticRenderFns } from "./AnzahlView.vue?vue&type=template&id=657f7d2e"
import script from "./AnzahlView.vue?vue&type=script&lang=js"
export * from "./AnzahlView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports